var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhyChoose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64272 27.9973C14.3766 27.9973 18.2141 24.1598 18.2141 19.4259C18.2141 14.6921 14.3766 10.8545 9.64272 10.8545C4.90885 10.8545 1.07129 14.6921 1.07129 19.4259C1.07129 24.1598 4.90885 27.9973 9.64272 27.9973Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3566 27.9973C25.0905 27.9973 28.928 24.1598 28.928 19.4259C28.928 14.6921 25.0905 10.8545 20.3566 10.8545C15.6227 10.8545 11.7852 14.6921 11.7852 19.4259C11.7852 24.1598 15.6227 27.9973 20.3566 27.9973Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 19.4261C19.734 19.4261 23.5716 15.5885 23.5716 10.8546C23.5716 6.12076 19.734 2.2832 15.0001 2.2832C10.2663 2.2832 6.42871 6.12076 6.42871 10.8546C6.42871 15.5885 10.2663 19.4261 15.0001 19.4261Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhyChoose2);
export default __webpack_public_path__ + "static/media/icon-why-choose-2.3288c8324d59c3635b8c53b1c0e1c7a1.svg";
export { ForwardRef as ReactComponent };